<template>
  <div class="better-transition-group">
    <slot></slot>
  </div>
</template>

<style lang="scss">
.better-transition-group {
  .transition-panel {
    width: 100%;
    transform: translateX(0);
  }
}

.collapse {
  .better-transition-group {
    .transition-panel {
      animation-name: menuSlideRight;
      animation-duration: 0.3s;
      animation-fill-mode: both;
    }
  }
}

.expand {
  .better-transition-group {
    .transition-panel {
      animation-name: menuSlideLeft;
      animation-duration: 0.3s;
      animation-fill-mode: both;
    }
  }
}

@keyframes menuSlideRight {
  0% {
    visibility: hidden;
    transform: translateX(-100%);
  }

  to {
    visibility: visible;
    transform: translateX(0);
  }
}

@keyframes menuSlideLeft {
  0% {
    visibility: hidden;
    transform: translateX(100%);
  }

  to {
    visibility: visible;
    transform: translateX(0);
  }
}
</style>
